import type { CustomerwebSchemas } from "api-types";
import { useToast } from "@wayflyer/flyui";
import { useEffect } from "react";
import type { BankConnectCountryConfig } from "shared-ui";
import { useErrorModal } from "shared-ui";

import { getBankconnectUrls } from "../../urls";

type UseBankConnectWithMockedProps = CustomerwebSchemas.MockedBankConnectSchema & { customerSlug: string };

export function useBankConnectWithMocked({ enabled, customerSlug }: UseBankConnectWithMockedProps) {
  const connectPath = getBankconnectUrls(customerSlug).mockedConnect;
  const toaster = useToast();
  const { openErrorModal } = useErrorModal();

  const urlParams = new URLSearchParams(window.location.search);
  const isMockedCallback = urlParams.get("complete-connection") === "mocked";
  const mockedError = urlParams.has("mocked-error");

  useEffect(() => {
    if (isMockedCallback) {
      if (!mockedError) {
        toaster.positive("Successfully connected mock bank account");
      } else {
        openErrorModal({
          variant: "unknown",
          error: new Error(urlParams.get("mocked-error") || "Mocked bank connection failed"),
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function startConnect(countrySelection?: BankConnectCountryConfig) {
    if (!enabled) {
      openErrorModal({
        variant: "unknown",
        error: new Error("Mocked banking is not enabled"),
      });
      return;
    }

    const connectUrl = new URL(`${window.location.origin}${connectPath}`);
    if (countrySelection) {
      connectUrl.searchParams.append("country_code", countrySelection.code);
    }
    connectUrl.searchParams.append("redirect_uri", window.location.pathname);
    window.location.href = connectUrl.href;
  }

  return {
    startConnect,
  };
}
